<script>
import {notificationMethods, lmsCourseMethods, lmsUserMethods, uploadMethods, courseMethods} from "@/state/helpers";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";
//import {required} from "vuelidate/lib/validators";
import Cookies from "js-cookie";
import api from "@/helpers/axios";
import Multiselect from 'vue-multiselect'
import CustomerUsersSessions from "./widgets/sessions";
import AgreementSessions from "./widgets/sessions/AgreementSessions.vue";
/**
 * Advanced table component
 */
export default {
  props: {
    customerUserId: {
      type: String,
      required: true
    },
  },
  page: {
    title: "Kullanıcı Detay",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    CustomerUsersSessions,
    AgreementSessions,
    Layout,
    PageHeader,
    Toast,
    Multiselect
  },
  data() {
    return {
      educationSelected: false,
      filteredCourseOptions: [],
    /*  docs: [],*/
      total: 0,
      limit: 0,
      pages: 0,
      value: [],
      title: "Kullanıcı Detay",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Kullanıcılar",
          href: "/customerUsers"
        },
        {
          text: "Kullanıcı Detay",
          active: true,
        },
      ],
      currentUser: JSON.parse(Cookies.get('user')),
      //
      educations: [],
      education: this.educations,
//
      selectedEducation: null,

      courses: [],
      //
      selectedCourses: [],
      courseOptions: [],
      //
      toastAction: '',
      toastMessage: '',
      showToast: false,
      itemsLoaded: false,
      items: [],
      //
      courseItems: [],
      courseFields: [
        {
          key: "education",
          label: "Eğitim",
        },{
          key: "name",
          label: "Kurs",
        },
        {
          key: "level",
          label: "Kurlar",
        },{
          key: "advisor",
          label: "Danışman",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      //
      showCourseModal: false,
      //
      course: {},
      coursesLoaded: false,
      courseAddSubmitted: false,
      noCoursedeleteCourseModal: false,
      //
      deleteCourseModal: false,
      deleteCourseId: '',

      //
      jointCourseFilter: '',
      totalRows: 1,
      page: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "createdAt",
      sortDesc: false,
      addForm: {
      },
      user: {}
    };
  },
  validations: {
    addForm: {},
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
  },
  watch: {
    selectedEducation(newEducation) {
      if (newEducation) {
        this.educationSelected = true;
        this.loadCourses();
      } else {
        this.educationSelected = false;
      }
    },
  },

  mounted() {
  this.getLmsUser();
   this.getLmsCourses()
  },

  methods: {
    ...lmsCourseMethods,
    ...lmsUserMethods,
    ...notificationMethods,
    ...uploadMethods,
    ...courseMethods,
    onPageChange(newPage) {
      this.page = newPage;
      this.getLmsCourses();
    },
    onEducationChange() {
      const selectedEducationId = this.selectedEducation;
      this.selectedEducation = selectedEducationId;
      this.loadCourses();
      /* eslint-disable */
    //  console.log(this.selectedEducation + "test 1");
    },
    loadCourses() {
      if (this.selectedEducation) {
        api.get(`/courses?education=${this.selectedEducation}`)
            .then((response) => {
              this.courseOptions = response.data.data.docs;
              /* eslint-disable */
           //   console.log(this.selectedEducation + "test 2");
            })
            .catch(() => {});
      } else {
        this.courseOptions = [];
      }
    },
    getLmsUser() {
      this.itemsLoaded = false
      this.fetchLmsUser({id:this.customerUserId}, ).then(res => {
        this.user = res
        this.fetchEducations();
        this.itemsLoaded = true
      })
    },
    getLmsCourses() {
      this.itemsLoaded = false;
      this.fetchLmsCourses({
        page: this.page,
        limit: this.perPage,
        search: this.search,
        customerUserId: this.customerUserId,

      })
          .then((res) => {
            this.totalRows = res.total;
           this.courseItems = res.docs;
            this.itemsLoaded = true;
          });
    },
    getCourses() {
      this.itemsLoaded = false;
      this.fetchCourses({
       page: this.page,
        limit: this.perPage,
        search: this.search,
        education: this.selectedEducation,
      })
          .then((res) => {
            this.totalRows = res.total;
        //   this.courseItems = res.docs;
           this.itemsLoaded = true;
            this.selectedCourses = res.docs.map(course => {
              return course
            });
          });
    },

    async fetchEducations() {
      try {
        const response = await api.get(`/educations?site=${this.user._site.id}`, );
        this.educations = response.data.data.docs;
      } catch (error) {
        return;
      }
    },

    formatEducation(education) {
      return education
    },
    handleCourseSubmit() {
      this.courseAddSubmitted = true;
      this.formError = "";
      this.$v.addForm.$touch();
      if (this.$v.addForm.$invalid) {
        return;
      }
      const data = {
        ...this.addForm,
        courses: this.selectedCourses.map(course => course._id),
      };
      const customerUserId = this.$route.params.customerUserId;
      this.createLmsCourse({
        data, customerUserId
      })
          .then(() => {
            this.toastMessage = "Kurs başarıyla eklendi!";
            this.toastAction = "success";
            this.showToast = true;
            setTimeout(() => {
              this.showToast = false;
            }, 3000);
            this.getLmsCourses();
            this.showCourseModal = false;
            this.selectedEducation = "";
            this.selectedCourses = [];
          })
          .catch((err) => {
            if (err == 'TCNUMBER_ALREADY_USE') {
              this.formError = "Girilen TC numarasına sahip bir kurs bulunmaktadır.";
            } else {
              this.toastMessage = "Sistemde bir hata oluştu!";
              this.toastAction = "error";
              this.showToast = true;
              setTimeout(() => {
                this.showToast = false;
              }, 3000);

            }
          });
    },

    handleCourseDeleteSubmit() {
      const customerUserId = this.$route.params.customerUserId;
   //   const customerCourseId = this.$route.params.customerCourseId;
      this.deleteLmsCourse({customerCourseId: this.deleteCourseId, customerUserId}).then(() => {
        this.deleteCourseModal = false;
        this.toastMessage = "Kurs başarıyla silindi!";
        this.toastAction = "success";
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 3000)
        this.getLmsCourses();
      })
    },
    openAdd() {
      this.jointCourseFilter = ''
      this.showCourseModal = true;
    },
    openDelete(course) {
      if (course.email === this.currentUser.email) {
        this.noCoursedeleteCourseModal = true;
      } else {
        this.deleteCourseId = course.customerCourse;
        this.deleteCourseModal = true;
      }
    },
    //
    moneyFormat(value) {
      return new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY",
      }).format(value);
    }
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems"/>
<!--    <div>{{ customerUserId }}</div>-->
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row" v-if="itemsLoaded ">
      <div class="col-12">
        <div class="card">
          <div class="card-body row">
            <div class="table-responsive col-6">
              <table class="table table-nowrap mb-0">
                <tbody>
                <tr>
                  <th scope="row">Adı :</th>
                  <td>{{ user?.name }}</td>
                </tr>
                <tr>
                  <th scope="row">E-Posta :</th>
                  <td>{{ user?.email }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="table-responsive col-6">
              <table class="table table-nowrap mb-0">
                <tbody>
                <tr>
                  <th scope="row">Telefon :</th>
                  <td>{{ user?.phone.replace(/\D/g, '')  }}</td>
                </tr>
                <tr>
                  <th scope="row">Site :</th>
                  <td>{{ user?._site?.name }}</td>
                </tr>

                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
      <!--    course işlemleri-->
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex align-items-center">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <h5>Kurslar</h5>
                </div>

                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="openAdd"
                >
                  Kurs Ekle
                </button>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="courseItems"
                  :fields="courseFields"
                  responsive="sm"
              >
                <template v-slot:cell(name)="data">
                  {{ data.item.name }}
                </template>

                <template v-slot:cell(education)="data">
                  {{ formatEducation(data?.item?.education?.name) }}
                </template>    <template v-slot:cell(advisor)="data">
                {{ formatEducation(data?.item?.advisor?.name) }}
              </template>

                <template v-slot:cell(level)="data">
                  <ul>
                    <li v-for="level in data.item.level" :key="level.id">{{ level.name }}</li>
                  </ul>
                </template>
                <template v-slot:cell(course)="data">
                  <ul>
                    <li v-for="course in data.item.course" :key="course.id">{{ course.name }}</li>
                  </ul>
                </template>

                <template v-slot:cell(isActive)="data">
                  <span v-show="data.item.isActive"
                        class="badge badge-pill badge-soft-success font-size-13">Aktif</span>
                  <span v-show="!data.item.isActive"
                        class="badge badge-pill badge-soft-danger font-size-13">Pasif</span>
                </template>
                <template v-slot:cell(delete)="data">
                  <button
                      :disabled="currentUser.role.includes('user')"
                      class="btn btn-danger d-flex py-2"
                      @click="openDelete(data.item)"
                  >
                    <i :class="`bx bx-trash bx-xs`"></i>
                  </button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="page" :total-rows="totalRows" :per-page="perPage" @input="onPageChange"></b-pagination>

                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal size="md" v-model="showCourseModal" title="Kurs Ekle" hide-footer>
        <form @submit.prevent="handleCourseSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <div class="form-group">
                  <label for="site">Eğitim Seçiniz</label>
                  <select id="site" v-model="selectedEducation" class="form-control" @change="onEducationChange">
                    <option value="">Eğitim Seçiniz</option>
                    <option v-for="education in educations" :key="education.id" :value="education.id">{{ education.name }}</option>
                  </select>
                </div>
              </div>
            </div>
           <div class="col-12">
              <div class="mb-3">
                <div class="form-group">
                  <label for="site">Kurs Seçiniz</label>
                  <Multiselect
                      v-model="selectedCourses"
                      :options="courseOptions"
                      label="name"
                      track-by="id"
                      placeholder="Kurs Seçiniz"
                      multiple
                      :select-label="'Seçiniz'"
                  :selected-label="'Kaldır'"
                      :selected-text="'Kaldır'"
                  ></Multiselect>
                </div>
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showCourseModal = false">Vazgeç</b-button>
            <b-button type="submit" variant="success" class="ms-1">Kurs Ekle</b-button>
          </div>
        </form>
      </b-modal>
      <b-modal
          v-model="deleteCourseModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu kursu silmek istediğinize emin misiniz? Silinmiş kursu geri alamazsınız.
              </p>
              <form @submit.prevent="handleCourseDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
          v-model="noCoursedeleteCourseModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Silinemez !</h4>
              <p class="text-muted font-size-14 mb-4">
                Oturumunu açtığınız kursu silemezsiniz.
              </p>
            </div>
          </div>
        </div>
      </b-modal>
      <agreement-sessions :user="user.id"/>
      <customer-users-sessions :user="user.id"/>
    </div>
    <div class="spinner-wrapper" v-else>
      <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
    </div>
  </Layout>
</template>
<style>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}

.customSelect .dropdown-menu {
  width: 100% !important;
}

.customSelect .btn {
  text-align: left;
}

.pill span {
  padding: 6px 12px 4px 12px;
}
</style>

